import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'

import { EditPartnerRequestType } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { PartnerLegalInfo } from 'clickNgo/entities/partner/ui/partnerLegalInfo'
import { useGetFormDataField } from 'cng-common/features/form'

import { PARTNER_DATA_FORM_KEYS, PartnerDataFormKeys, PartnerDataFormSettings } from '../../configs'
import { PartnerDataFormContainer } from '../partnerDataFormContainer/PartnerDataFormContainer'
import { PartnerWorkflowStatusPanel } from '../partnerWorkflowStatusPanel/PartnerWorkflowStatusPanel'

import { useEditPartnerLegalInfoHandler } from './hooks/useEditPartnerLegalInfoHandler'
import { useLegalInfoMandatoryAttachments } from './hooks/useLegalInfoMandatoryAttachments'
import { usePartnerLegalInfoValidation } from './hooks/usePartnerLegalInfoValidation'

interface IPartnerLegalInfoWrapper {
  partner: IPartner
  isDisabled?: boolean
  isSaveAsDraft: boolean
}

export const PartnerLegalInfoWrapper = ({
  partner,
  isDisabled,
  isSaveAsDraft,
}: IPartnerLegalInfoWrapper) => {
  const { legalValidationProps } = usePartnerLegalInfoValidation({
    formKeys: PARTNER_DATA_FORM_KEYS,
  })

  const hasEntryId = Boolean(partner.entryId)

  const { handleOnPartnerLegalChangesApply, handleOnPartnerLegalChangesCancel } =
    useEditPartnerLegalInfoHandler({ partner })

  const { isAttachmentRequired } = useLegalInfoMandatoryAttachments({
    hasActiveAgreement: partner.hasActiveAgreement,
  })
  const [isInactive] = useGetFormDataField<boolean>(
    PartnerDataFormKeys.Setting,
    PartnerDataFormSettings.IsInactive
  )

  return (
    <PartnerDataFormContainer
      formKey={PartnerDataFormKeys.LegalInfo}
      onApply={handleOnPartnerLegalChangesApply}
      onCancel={handleOnPartnerLegalChangesCancel}
      isAttachmentRequired={isAttachmentRequired}
      isSaveAsDraft={isSaveAsDraft}
    >
      <RenderWhen condition={!isInactive}>
        <PartnerWorkflowStatusPanel
          type={EditPartnerRequestType.LEGAL}
          entryId={partner.entryId502}
          workflowStatus={partner.legalWorkflowStatus}
          partnerId={partner.partnerId}
          isDisabled={isDisabled}
        />
      </RenderWhen>
      <PartnerLegalInfo
        {...partner}
        {...legalValidationProps}
        isReadOnly={isDisabled}
        hasEntryId={hasEntryId}
        formKeys={PARTNER_DATA_FORM_KEYS}
      />
    </PartnerDataFormContainer>
  )
}
